import React, { useState, useEffect } from 'react';
import './Floating-B.css';

const FloatingBanner = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 30) { // Threshold for detecting scroll
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Clean up the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleRegisterClick = () => {
    window.open('https://fdp.enropesolutions.com/', '_blank');
  };

  return (
    <div className={`floating-banner ${scrolled ? 'scrolled' : ''}`}>
      <div className="banner-content">
        <p className="banner-text">Registration is now open for the 2025 Fitness Development Program!</p>
        <button className="register-button" onClick={handleRegisterClick}>Register Now</button>
      </div>
    </div>
  );
};

export default FloatingBanner;
